<template>
  <div :style="{ padding: '0 0 32px 32px' }">
    <div><slot></slot></div>
    <v-chart
      :height="height"
      :data="data"
      :forceFit="true"
      :scale="scale"
      :padding="['auto', 'auto', '40', '60']"
    >
      <v-tooltip />
      <v-axis />
      <v-bar position="xAxis*yAxis" />
    </v-chart>
  </div>
</template>

<script>
export default {
  name: 'Histogram',
  props: {
    chartOptions: {
      type: Object,
      default: {
        data: null,
        scale: null,
        tooltip: null,
        height: 400,
      },
    },
  },
  computed: {
    height() {
      return this.chartOptions && this.chartOptions.height
        ? this.chartOptions.height
        : 400
    },
    data() {
      return this.chartOptions && this.chartOptions.data
        ? this.chartOptions.data
        : null
    },
    scale() {
      return this.chartOptions && this.chartOptions.scale
        ? this.chartOptions.scale
        : null
    },
  },
}
</script>
